export default __webpack_public_path__ + "cc25a0afb4eb9915a3cadb87c7f1cc77.png";